<template>
    <section id="Invoice">
        <div class="o-color-change" data-logo-colors="logo-icon-is-color-1-darker, logo-text-is-color-1-darker"></div>
        <template v-if="loading">
            <div class="o-spinning-coin"></div>
        </template>
        <template v-else>
            <div v-if="error" class="o-text">
                <p>{{ error }} ({{ errorCode }})</p>
            </div>
            <template v-else>
                <div class="o-grid">
                    <div class="o-grid-12">
                        <h2 class="o-title-2">Merci de votre commande</h2>
                        <h3 class="o-title-3">Numéro de facture&nbsp;: <span>{{ invoice.invoice_number }}</span></h3>
                    </div>
                    <div class="o-grid-6">
                        <h3 class="o-title-5">Informations client</h3>
                        <div class="o-text">
                            <p>Facturé à&nbsp;: {{ invoice.cart_data.billing_address.first_name }} {{ invoice.cart_data.billing_address.last_name }}</p>
                            <p>{{ invoice.cart_data.billing_address.email }}</p>
                        </div>
                    </div>
                    <div class="o-grid-6">
                        <h3 class="o-title-5">Informations de facturation</h3>
                        <div class="o-text">
                            <p>{{ invoice.cart_data.billing_address.address_1 }} {{ invoice.cart_data.billing_address.address_2 }}</p>
                            <p>{{ invoice.cart_data.billing_address.city }} {{ invoice.cart_data.billing_address.postcode }}</p>
                            <p>{{ invoice.cart_data.billing_address.country }}</p>
                        </div>
                    </div>

                    <div class="o-grid-12">
                        <h3 class="o-title-5">Détails de la commande</h3>
                        <div class="c-block-table__content">
                            <table class="o-table -table-striped">
                                <thead>
                                    <tr>
                                        <th>Produit</th>
                                        <th>Quantité</th>
                                        <th>Prix</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in invoice.cart_data.items" :key="item.id">
                                        <td>{{ item.name }}<br>{{ item.description }}</td>
                                        <td>{{ item.quantity }}</td>
                                        <td>{{ formatMoney(item.price) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="o-grid-12">
                        <h3 class="o-title-5">Total</h3>
                        <div class="c-block-table__content">
                            <table class="o-table -table-striped">
                                <tbody>
                                    <tr v-if="invoice.cart_data.subtotal != invoice.cart_data.total">
                                        <td>Sous-total</td>
                                        <td>{{ formatMoney(invoice.cart_data.subtotal) }}</td>
                                    </tr>
                                    <tr v-if="invoice.cart_data.shipping_total > 0">
                                        <td>Livraison</td>
                                        <td>{{ formatMoney(invoice.cart_data.shipping_total) }}</td>
                                    </tr>
                                    <tr v-if="invoice.cart_data.discount_total > 0">
                                        <td>Rabais</td>
                                        <td>{{ formatMoney(invoice.cart_data.discount_total) }}</td>
                                    </tr>
                                    <tr v-for="tax in invoice.cart_data.taxes" :key="tax.id">
                                        <td>{{ tax.name }} ({{ tax.number }})</td>
                                        <td>{{ formatMoney(tax.amount) }}</td>
                                    </tr>
                                    <tr>
                                        <td>Total</td>
                                        <td>{{ formatMoney(invoice.cart_data.total) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!--Note-->
                    <div v-if="invoice.note" class="o-grid-12">
                        <h3 class="o-title-5">Note</h3>
                        <div class="o-text o-text-lg">
                            <p>{{ invoice.note }}</p>
                        </div>
                    </div>
                </div>
            </template>
        </template>
    </section>
</template>
<script>
import axios from 'axios'
export default {
    name: 'CustomerInvoice',
    data() {
        return {
            invoice: {},
            token: null,
            error: null,
            errorCode: null,
            loading: true,
            invoice_id: null,
        }
    },
    methods: {
        getInvoice(){
            let params = {
                invoice_token: this.invoice_token,
                _wpnonce: window.ajax_var.nonce
            }

            //Add headers type
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            axios.get('/wp-json/stereostore/v1/invoice', { params })
                .then(response => {
                    this.invoice = response.data
                    this.loading = false
                })
                .catch(error => {
                    this.error = error.response.data.message
                    this.errorCode = error.response.data.code
                    this.loading = false
                })
        },
        formatMoney(value) {
            let language = 'fr';
            let currency = 'CAD';
            var formatter = new Intl.NumberFormat(language, {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'narrowSymbol'
            });
            return formatter.format(value);
        },
    },
    mounted() {
        //Get id param from url
        if(window.location.search) {
            let params = new URLSearchParams(window.location.search)
            this.invoice_token = params.get('token')
        }
        if(!this.invoice_token) {
            location.href = '/404/'
        }

        this.getInvoice();
        document.body.classList.add('u-bg-color-1', 'u-color-1-darker', 't-cart')
        document.querySelector('.c-footer__inner').classList.add('u-bg-color-3-darker', 'u-color-3-light')
        document.querySelector('.c-footer').style.display = 'none'
    }
}
</script>